// noinspection JSCheckFunctionSignatures

import React from 'react';
import { Route, Routes } from 'react-router';


export default function AppCustom(props) {

    const REC010 = React.lazy(() => import('./pages/_custom/recepcion/REC010'));
    const REC011 = React.lazy(() => import('./pages/_custom/recepcion/REC011'));
    const REC012 = React.lazy(() => import('./pages/_custom/recepcion/REC012'));
    const REC141 = React.lazy(() => import('./pages/_custom/recepcion/REC141'));
    const REC170 = React.lazy(() => import('./pages/_custom/recepcion/REC170'));
    const REC275 = React.lazy(() => import('./pages/_custom/recepcion/REC275'));

    const STO150 = React.lazy(() => import('./pages/_custom/stock/STO150'));
    const STO850 = React.lazy(() => import('./pages/_custom/stock/STO850'));
    const STO860 = React.lazy(() => import('./pages/_custom/stock/STO860'));
    const STO830 = React.lazy(() => import('./pages/_custom/stock/STO830'));
    const STO840 = React.lazy(() => import('./pages/_custom/stock/STO840'));
    const STO870 = React.lazy(() => import('./pages/_custom/stock/STO870'));

    const PRE100 = React.lazy(() => import('./pages/_custom/preparacion/PRE100'));
    const PRE120 = React.lazy(() => import('./pages/_custom/preparacion/PRE120'));
    const PRE130 = React.lazy(() => import('./pages/_custom/preparacion/PRE130'));
    const PRE150 = React.lazy(() => import('./pages/_custom/preparacion/PRE150'));

    const REG040 = React.lazy(() => import('./pages/_custom/registro/REG040'));
    const REG800 = React.lazy(() => import('./pages/_custom/registro/REG800'));
    const REG801 = React.lazy(() => import('./pages/_custom/registro/REG801'));

    const COF120 = React.lazy(() => import('./pages/_custom/configuracion/COF120'));
    const INT050 = React.lazy(() => import('./pages/_custom/interfaz/INT050'));

    const INV410 = React.lazy(() => import('./pages/_custom/inventario/INV410'));
    const INV413 = React.lazy(() => import('./pages/_custom/inventario/INV413'));
    const INV414 = React.lazy(() => import('./pages/_custom/inventario/INV414'));

    const EXP040 = React.lazy(() => import('./pages/_custom/expedicion/EXP040'));
    const IMP800 = React.lazy(() => import('./pages/_custom/impresion/IMP800'));

    return (
        <Routes>
            <Route path='/recepcion/REC010' element={<REC010 {...props} />} />
            <Route path='/recepcion/REC011' element={<REC011 {...props} />} />
            <Route path='/recepcion/REC012' element={<REC012 {...props} />} />
            <Route path='/recepcion/REC141' element={<REC141 {...props} />} />
            <Route path='/recepcion/REC170' element={<REC170 {...props} />} />
            <Route path='/recepcion/REC275' element={<REC275 {...props} />} />

            <Route path='/stock/STO150' element={<STO150 {...props} />} />
            <Route path='/stock/STO850' element={<STO850 {...props} />} />
            <Route path='/stock/STO860' element={<STO860 {...props} />} />
            <Route path='/stock/STO830' element={<STO830 {...props} />} />
            <Route path='/stock/STO840' element={<STO840 {...props} />} />
            <Route path='/stock/STO870' element={<STO870 {...props} />} />

            <Route path='/preparacion/PRE100' element={<PRE100 {...props} />} />
            <Route path='/preparacion/PRE120' element={<PRE120 {...props} />} />
            <Route path='/preparacion/PRE130' element={<PRE130 {...props} />} />
            <Route path='/preparacion/PRE150' element={<PRE150 {...props} />} />

            <Route path='/inventario/INV410' element={<INV410 {...props} />} />
            <Route path='/inventario/INV413' element={<INV413 {...props} />} />
            <Route path='/inventario/INV414' element={<INV414 {...props} />} />
            <Route path='/interfaz/INT050' element={<INT050 {...props} />} />

            <Route path='/registro/REG040' element={<REG040 {...props} />} />
            <Route path='/registro/REG800' element={<REG800 {...props} />} />
            <Route path='/registro/REG801' element={<REG801 {...props} />} />
            
            <Route path='/configuracion/COF120' element={<COF120 {...props} />} />

            <Route path='/expedicion/EXP040' element={<EXP040 {...props} />} />
            <Route path='/impresion/IMP800' element={<IMP800 {...props} />} />
        </Routes>
    );
}
